export const headTraumaChecks = {
  NOT_DISCUSSED: 'notDiscussed',
  NONE_REPORTED: 'noneReported',
  DISCUSSED_IN_PREVIOUS_CALLS: 'discussedInPreviousCalls',
  DISCUSSED_BUT_UNKNOWN: 'discussedButUnknown',
  REPORTED: 'reported'
}

export const callEntryTypes = [
  { value: 'lawEnforcement', label: 'Law Enforcement' },
  { value: 'wrongNumber', label: 'Wrong Number' },
  { value: 'nonLawEnforcement', label: 'Non-Law Enforcement' },
  { value: 'noCaller', label: 'No Caller' },
  { value: 'thirdPartyCaller', label: '3rd Party Caller' },
  { value: 'vettingCall', label: 'Vetting Call' },
  { value: 'non800LineContact', label: 'Non 800 Line Contact' }
]

export const coplineRoles = [
  { label: 'SuperAdmin', value: 'SuperAdmin' },
  { label: 'HrAdmin', value: 'HrAdmin' },
  { label: 'ProviderQuestionnaireAdmin', value: 'ProviderQuestionnaireAdmin' },
  { label: 'ProviderAdmin', value: 'ProviderAdmin' },
  { label: 'Volunteer', value: 'Volunteer' },
  { label: 'ProvidersAccess', value: 'ProvidersAccess'}
]

export default function getLookups () {
  const militaryBranches = [
    { value: 'airForce', label: 'Air Force' },
    { value: 'army', label: 'Army' },
    { value: 'coastGuard', label: 'Coast Guard' },
    { value: 'marineCorps', label: 'Marine Corps' },
    { value: 'navy', label: 'Navy' }
  ]
  const veteranRanks = [
    { value: 'recruit', label: 'Recruit' },
    { value: 'policeOfficer', label: 'Police Officer' },
    { value: 'trooper', label: 'Trooper' },
    { value: 'detective', label: 'Detective' },
    { value: 'corporal', label: 'Corporal' },
    { value: 'sergeant', label: 'Sergeant' },
    { value: 'lieutenant', label: 'Lieutenant' },
    { value: 'captain', label: 'Captain' },
    { value: 'commander', label: 'Commander' },
    { value: 'deputyCommander', label: 'Deputy Commander' },
    { value: 'deputyChief', label: 'Deputy Chief' },
    { value: 'chief', label: 'Chief' },
    { value: 'director', label: 'Director' },
    { value: 'evidenceTechnician', label: 'Evidence Technician' },
    { value: 'agent', label: 'Agent' },
    { value: 'retired', label: 'Retired' },
    { value: 'correctionsOfficer', label: 'Corrections Officer' },
    { value: 'other', label: 'Other' }
  ]
  const callerTypes = [
    { value: 'coWorker', label: 'Co-Worker' },
    { value: 'familyMember', label: 'Family Member' },
    { value: 'friend', label: 'Friend' },
    { value: 'officer', label: 'Officer' },
    { value: 'romanticPartner', label: 'Romantic Partner' },
    { value: 'spouse', label: 'Spouse' },
    { value: 'workPartner', label: 'Work Partner' }
  ]
  const coplineReferralReasons = [
    { value: `Didn't ask`, label: `Didn't ask` },
    { value: '988', label: '988' },
    { value: 'Previous Caller', label: 'Previous Caller' },
    { value: 'Conference', label: 'Conference'},
    { value: 'Police Union/Department', label: 'Police Union/Department' },
    { value: 'Co-Worker', label: 'Co-Worker' },
    { value: 'Facebook', label: 'Facebook' },
    { value: 'Family Member', label: 'Family Member' },
    { value: 'Frequent caller', label: 'Frequent caller' },
    { value: 'Friend', label: 'Friend' },
    { value: 'Google', label: 'Google' },
    { value: 'Internet', label: 'Internet' },
    { value: 'Media', label: 'Media' },
    { value: 'Podcast', label: 'Podcast' },
    { value: 'Poster', label: 'Poster' },
    { value: 'Spouse Referral', label: 'Spouse Referral' },
    { value: 'Supervisor', label: 'Supervisor' },
    { value: 'Therapist', label: 'Therapist' },
    { value: 'Union Rep', label: 'Union Rep' },
    {value:'wellnessApp', label:'Wellness App'},
    { value: 'AI (ChatGPT, Gemini, Etc)', label: 'AI (ChatGPT, Gemini, Etc)' },
    { value: 'Other', label: 'Other' }
  ]
  const impairmentReasons = [
    { value: 'noneDetected', label: 'None Detected' },
    { value: 'headInjury/TBI', label: 'Head Injury/TBI'},
    { value: 'drinkingNotIntoxicated', label: 'Drinking/Not Intoxicated' },
    { value: 'drinkingIntoxicated', label: 'Drinking/Intoxicated' },
    { value: 'notDrinkingNoProblems', label: 'Not Drinking, reported no problems with alcohol' },
    { value: 'notDrinkingProblems', label: 'Not Drinking, reported having problems with alcohol use' },
    { value: 'notDiscussed', label: 'Not discussed' },
    { value: 'drugs', label: 'Drugs' },
    { value: 'other', label: 'Other' },
  ]
  const callerStruggles = [
    { value: 'medicalRetirement', label: 'Medical Retirement' },
    { value: 'forcedRetirementTermination', label: 'Forced Retirement/Termination' },
    { value: 'injuries', label: 'Injuries' },
    { value: 'psychologicalDistress', label: 'Psychological Distress' },
    { value: 'relationshipIssues', label: 'Relationship Issues' },
    { value: 'administrativeIssues', label: 'Administrative Issues(Demotion, IA\'s, etc.)' },
    { value: 'other', label: 'Other' }
  ]
  const timeZones = [
    { value: 'eastern', label: 'Eastern' },
    { value: 'central', label: 'Central' },
    { value: 'mountain', label: 'Mountain' },
    { value: 'pacific', label: 'Pacific' },
    { value: 'hawaii', label: 'Hawaii' },
    { value: 'alaska', label: 'Alaska' },
  ]
  const providers = [ // TODO get real provider types from api
    { value:'alcoholics_anonymous', label: 'AA (Alcoholics Anonymous)' },
    { value:'financial_advisors', label: 'Financial Services' },
    { value:'firefighters_ems_hotline', label: 'Firefighters/EMS Hotline' },
    { value:'inpatient', label: 'Inpatient (Detox)' },
    { value:'intensive_outpatient_treatment', label: 'Intensive Outpatient Treatment (IOP)' },
    { value:'legal_advisor', label: 'Legal Advisor (Not covered by Unions)' },
    { value:'neurology', label: 'Neurology' },
    { value:'organization', label: 'Organization' },
    { value:'peace_officers', label: 'Peace Officer AA' },
    { value:'private_practice', label: 'Private Practice' },
    { value:'publication', label: 'Publication' },
    { value:'residential', label: 'Residential (Not Including Detox)' },
    { value:'retreats', label: 'Retreats' },
    { value:'support_groups', label: 'Support Groups' },
    { value:'temp_national_crisis_disaster_help', label: 'Temp National Crisis/Disaster Help' },
    { value:'treatment_placement_assistance', label: 'Treatment Placement Assistance' },
    { value:'psypact_telehealth', label: 'Psypact Telehealth' },
    { value:'other', label: 'Other' }
  ];
  const countries = [
    { label: 'United States of America', value: 'USA' },
    { label: 'Canada', value: 'CANADA' },
    { label: 'Australia', value: 'AUSTRALIA' }
  ]
  const headTraumas = [
    { value: 'motorVehicleAccident', label: 'Motor Vehicle Accident(s)' },
    { value: 'playedContactSports', label: 'Played Contact Sports' },
    { value: 'swat', label: 'SWAT' },
    { value: 'firearmsInstructor', label: 'Firearms Instructor ' },
    { value: 'breacher', label: 'Breacher' },
    { value: 'lossOfConsciousness', label: 'Loss of Consciousness at any time in life' },
    { value: 'corporalPunishment', label: 'Corporal punishment' },
    { value: 'specialyUnit', label: 'Specialty Unit' },
    { value: 'military', label: 'Military' },
    { value: 'knownConcussion(s)', label: 'Known Concussion(s)' },
    { value: 'strangulation', label: 'Strangulation' },
    { value: 'fall(s)', label: 'Fall(s)' },
    { value: 'bellRung', label: 'Bell Rung' },
    { value: 'domesticViolence', label: 'Domestic Violence' }
  ]

  return { veteranRanks, callerStruggles, callerTypes, coplineReferralReasons, impairmentReasons, militaryBranches, timeZones, providers, countries, callEntryTypes, coplineRoles, headTraumaChecks, headTraumas }
}